<template>
  <b-col cols="12" class="bk-footer">
    <b-row>
      <b-col md="3" class="bk-footer__column">
        <div class="bk-footer__badge bk-footer__badge--empty"></div>
        <div class="bk-footer__title">Viaggia con {{ site.brand }} {{ site.payoff }}</div>
        <ul class="bk-footer__links">
          <li>
            <router-link :to="{ name: 'about' }">Cos’è {{ site.name }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'prenota-un-viaggio' }">Prenota un viaggio</router-link>
          </li>
        </ul>
      </b-col>

      <b-col md="3" class="bk-footer__column">
        <div class="bk-footer__badge">
          <vb-icon name="shield" :size="16" :color="sass('gray-900')" />
        </div>
        <div class="bk-footer__title">Legal</div>
        <ul class="bk-footer__links">
          <li>
            <router-link :to="{ name: 'terms' }">Termini e condizioni</router-link>
          </li>
          <li v-if="site.urlPrivacy">
            <a :href="site.urlPrivacy" target="_blank" rel="noopener">Privacy Policy</a>
          </li>
          <li v-if="site.urlCookiePolicy">
            <a :href="site.urlCookiePolicy" target="_blank" rel="noopener">Cookie Policy</a>
          </li>
        </ul>
      </b-col>

      <b-col md="3" class="bk-footer__column">
        <div class="bk-footer__badge">
          <vb-icon name="envelope" :size="16" :color="sass('gray-900')" />
        </div>
        <div class="bk-footer__title">Supporto</div>
        <ul class="bk-footer__links">
          <li>
            <router-link :to="{ name: 'faq' }">Contatta l’assistenza clienti</router-link>
          </li>
        </ul>
      </b-col>
    </b-row>

    <div class="bk-footer__bottom">
      <span>© {{ current_year }} Salabam Solutions</span>
      <router-link :to="{ name: 'faq' }" class="bk-footer__contact">
        <vb-icon name="envelope" :size="14" :color="'ffffff'" />
        Contattaci
      </router-link>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "site-footer",
  data() {
    return {
      site: this.$config.site,
      current_year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.bk-footer {
  text-align: left;

  &__column {
    margin-bottom: $grid-gutter-width;
  }

  &__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-bottom: $grid-gutter-width / 4;
    background-color: $gray-200;
    border-radius: 50%;

    &--empty {
      visibility: hidden;

      @include media-breakpoint-down(sm) {
        display: none;
      }
    }
  }

  &__title {
    margin-bottom: $grid-gutter-width / 3;
    font-size: $font-size-base;
    font-weight: $vb-font-weight-semibold;
    color: $white;
  }

  &__links {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      margin-bottom: $grid-gutter-width / 6;
      font-size: $font-size-md;
      line-height: 1.4;
    }
  }

  a {
    display: inline;
    color: $white;

    &:visited,
    &:active {
      color: $white;
    }

    &:hover,
    &:focus {
      color: $white;
      text-decoration: underline;
    }
  }

  &__bottom {
    display: flex;
    flex-wrap: wrap;
    gap: $grid-gutter-20 / 2;
    align-items: center;
    justify-content: space-between;
    padding: $grid-gutter-width 0;
    font-size: $font-size-md;
    color: $white;
    border-top: 1px solid rgba($white, .3);
  }

  & &__contact {
    display: inline-flex;
    gap: $grid-gutter-width / 6;
    align-items: center;
  }
}
</style>
